export const categories = [
  {
    slug: "meinv-xiezhen",
    name: "美女写真",
    description: "精选全网高质量美女写真图集，涵盖日系、韩系、欧美等多种风格，每日更新优质内容。",
    icon: "ri-camera-lens-line",
    count: 128,
    keywords: ["写真", "图集", "摄影", "人像"],
  },
  {
    slug: "shishang-chuanda",
    name: "时尚穿搭",
    description: "最新时尚潮流穿搭指南，明星博主穿搭解析，季节搭配技巧分享。",
    icon: "ri-t-shirt-line",
    count: 96,
    keywords: ["穿搭", "时尚", "搭配", "潮流"],
  },
  {
    slug: "meizhuang-jiaocheng",
    name: "美妆教程",
    description: "专业美妆教程，从基础护肤到高级彩妆，手把手教你变美秘籍。",
    icon: "ri-brush-line",
    count: 85,
    keywords: ["美妆", "护肤", "彩妆", "化妆"],
  },
  {
    slug: "shenghuo-fangshi",
    name: "生活方式",
    description: "分享精致生活方式，健身塑形、美食旅行、家居美学等高品质生活内容。",
    icon: "ri-heart-line",
    count: 73,
    keywords: ["生活", "健身", "旅行", "美食"],
  },
  {
    slug: "bozhu-tuijian",
    name: "博主推荐",
    description: "推荐全网优质时尚美妆博主，发现更多宝藏内容创作者。",
    icon: "ri-star-line",
    count: 56,
    keywords: ["博主", "网红", "推荐", "达人"],
  },
  {
    slug: "xiezhen-tuji",
    name: "写真图集",
    description: "精美写真图集欣赏，日系清新、韩系唯美、国风古韵等多元风格。",
    icon: "ri-image-line",
    count: 142,
    keywords: ["写真", "图集", "唯美", "清新"],
  },
];

export const categorySlugMap: Record<string, (typeof categories)[number]> = {};
categories.forEach((cat) => {
  categorySlugMap[cat.slug] = cat;
});